<template>
  <div class="notifications" v-show="activeNotifications.length">
    <transition-group name="notifications">
      <div class="notifications-item"
        v-for="n in activeNotifications"
        :key="n.id"
      >
        <ui-notification
          closable
          :title="n.title"
          :color="n.color"
          @remove="REMOVE_NOTIFICATION(n.id)"
        >
          {{ n.message }}
        </ui-notification>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	computed: {
		...mapGetters({
			NOTIFICATIONS: 'notifications/list',
		}),

		activeNotifications() {
			return this.NOTIFICATIONS.slice(0, 4);
		},
	},

  methods: {
    ...mapActions({
      REMOVE_NOTIFICATION: 'notifications/remove',
    }),
  }
};
</script>

<style lang="scss">
.notifications {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  padding: 24px 10px;
  z-index: 10000;

  .ui-notification {
    margin: 0 0 12px;
  }

  /* transition */
  .notifications-item {
    transition: all .4s ease;
  }

  &-enter-active,
  &-leave-to {
    transform: translateX(0);
    max-height: 112px;
  }
  &-enter,
  &-leave-active {
    transform: translateX(120%);
    max-height: 0;
  }
}

@include breakpoint("tablet") {
  .notifications {
    width: 320px;
    padding: 24px;
  }
}

@include breakpoint("desktop") {
  .notifications {
    padding: 32px;

    .ui-notification {
      margin: 0 0 16px;
    }
  }
}

</style>
